import React, { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import './PatientLayout.css';

function PatientLayout() {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navItems = [
    { path: '/app/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/app/symptoms', label: 'Log Symptoms', icon: '📝' },
    { path: '/app/quiz', label: 'Daily Quiz', icon: '🧠' },
    { path: '/app/smartwatch', label: 'Smartwatch Data', icon: '⌚' }
  ];

  return (
    <div className="patient-layout">
      {/* Header */}
      <header className="patient-header">
        <div className="patient-header-content">
          <button 
            className="menu-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            ☰
          </button>
          <h1>Hemicron</h1>
          <Link to="/" className="exit-btn">Exit Prototype</Link>
        </div>
      </header>

      <div className="patient-container">
        {/* Sidebar Navigation */}
        <aside className={`patient-sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <nav className="patient-nav">
            {navItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </Link>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="patient-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default PatientLayout;


